import { render, staticRenderFns } from "./ClaimAuditTab.vue?vue&type=template&id=7540f254"
import script from "./ClaimAuditTab.vue?vue&type=script&lang=js"
export * from "./ClaimAuditTab.vue?vue&type=script&lang=js"
import style0 from "./ClaimAuditTab.vue?vue&type=style&index=0&id=7540f254&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports